<template>
	<form class="wide" @submit.prevent="submit">
		<loader v-if="!formReady"/>
		<template v-else>
			<fieldset v-if="'post' === this.method">
				<div>
					<div>
						<legend><span>Configuration</span></legend>
					</div>
					<div>
						<label><span>Service </span>
							<div v-if="form.errors.get('service')" class="error-block">
								<p v-html="form.errors.get('service')"></p>
							</div>
							<select v-model="form.data.service" @change="loadExistingFactFind">
								<option disabled selected value="">—</option>
								<option
									v-for="(service, serviceIndex) in form.options.services" :key="serviceIndex"
									:value="service.id" v-html="service.names.singular"/>
							</select>
						</label>
					</div>
				</div>
			</fieldset>
			<v-tabs v-slot="{ previous, next, goToPrevious, goToNext }" class="tabs--switch tabs--switch--shadow">
				<v-tab id="structure" v-slot="{ tabIndex }" label="Structure">
					<template v-for="(section, sectionIndex) in form.data.structure">
						<fieldset>
							<div>
								<div>
									<div class="flex gap-2 content-between items-start">
										<dl>
											<dt class="gamma all-caps">Section {{ sectionIndex + 1 }} Title</dt>
											<dd class="beta" v-html="sectionTitle(sectionIndex)"/>
										</dl>
										<v-contextual>
											<v-contextual-option
												@click.prevent="addSection(sectionIndex, true)">Add Section Above</v-contextual-option>
											<v-contextual-option
												@click.prevent="addSection(sectionIndex)">Add Section Below</v-contextual-option>
											<v-contextual-option
												v-if="multipleSections"
												@click.prevent="removeSection(sectionIndex)">Remove Section</v-contextual-option>
										</v-contextual>
									</div>
								</div>
								<div>
									<label><span>Title </span>
										<input v-model="form.data.structure[sectionIndex].title" type="text">
									</label>
									<label class="checkbox"><span>Include Script </span>
										<input
											v-model="form.data.structure[sectionIndex].includeScript" type="checkbox">
									</label>
									<label v-if="form.data.structure[sectionIndex].includeScript"><span>Script </span>
										<textarea v-model="form.data.structure[sectionIndex].script"></textarea>
									</label>
								</div>
							</div>
						</fieldset>
						<fieldset
							v-for="(question, questionIndex) in form.data.structure[sectionIndex].questions"
							:key="questionIndex">
							<div>
								<div>
									<div class="flex gap-2 content-between items-start">
										<dl>
											<dt class="gamma all-caps">Question {{ questionIndex + 1 }} Title</dt>
											<dd
												class="beta"
												v-html="questionTitle(sectionIndex, questionIndex)"/>
										</dl>
										<v-contextual>
											<v-contextual-option
												@click.prevent="addQuestion(sectionIndex, questionIndex, true)">Add Question Above</v-contextual-option>
											<v-contextual-option
												@click.prevent="addQuestion(sectionIndex, questionIndex)">Add Question Below</v-contextual-option>
											<v-contextual-option
												v-if="multipleQuestions(sectionIndex)"
												@click.prevent="removeQuestion(sectionIndex, questionIndex)">Remove Question</v-contextual-option>
										</v-contextual>
									</div>
								</div>
								<div>
									<label><span>Question </span>
										<input
											v-model="form.data.structure[sectionIndex].questions[questionIndex].question"
											type="text"
											@keyup="setDefaultInboundApiMapping(sectionIndex, questionIndex)">
									</label>
									<label><span>Type </span>
										<select
											v-model="form.data.structure[sectionIndex].questions[questionIndex].type">
											<option disabled selected value="">—</option>
											<option value="checkbox">Checkbox</option>
											<option value="money">Money</option>
											<option value="number">Number</option>
											<option value="select">Select</option>
											<option value="text">Text</option>
											<option value="textarea">Text Area</option>
										</select>
									</label>
									<label
										v-if="'select' === form.data.structure[sectionIndex].questions[questionIndex].type"><span>Select Field Options </span>
										<div
											v-for="(option, optionIndex) in form.data.structure[sectionIndex].questions[questionIndex].options"
											class="flex">
											<input
												v-model="form.data.structure[sectionIndex].questions[questionIndex].options[optionIndex].label"
												type="text">
											<v-contextual>
												<v-contextual-option
													@click.prevent="addOption(sectionIndex, questionIndex, optionIndex, true)">Add Option Above</v-contextual-option>
												<v-contextual-option
													@click.prevent="addOption(sectionIndex, questionIndex, optionIndex)">Add Option Below</v-contextual-option>
												<v-contextual-option
													v-if="multipleOptions(sectionIndex, questionIndex)"
													@click.prevent="removeOption(sectionIndex, questionIndex, optionIndex)">Remove Option</v-contextual-option>
											</v-contextual>
										</div>
									</label>
								</div>
							</div>
						</fieldset>
					</template>
					<div class="actions">
						<ul>
							<li>
								<button
									class="button button--primary"
									@click.prevent="goToNext">Preview
								</button>
							</li>
						</ul>
					</div>
				</v-tab>
				<!--				<v-tab class="section" v-slot="{ tabIndex }" id="mapping" label="API Mapping">-->
				<!--					<fieldset v-for="(section, sectionIndex) in form.data.structure" :key="sectionIndex">-->
				<!--						<div>-->
				<!--							<div>-->
				<!--								<legend v-if="section.title"><span v-html="section.title"></span></legend>-->
				<!--							</div>-->
				<!--							<div>-->
				<!--								<label-->
				<!--									v-for="(question, questionIndex) in form.data.structure[sectionIndex].questions"-->
				<!--									:key="questionIndex"><span v-html="question.question"/>-->
				<!--									<label><span>Outbound </span>-->
				<!--										<input-->
				<!--											type="text"-->
				<!--											v-model="form.data.structure[sectionIndex].questions[questionIndex].apiMapping.outbound">-->
				<!--									</label>-->
				<!--									<label class="checkbox"><span>Customize Inbound Name </span>-->
				<!--										<input-->
				<!--											type="checkbox"-->
				<!--											v-model="form.data.structure[sectionIndex].questions[questionIndex].apiMapping.customInbound"-->
				<!--											@change="resetDefaultInboundApiMapping(sectionIndex, questionIndex)">-->
				<!--									</label>-->
				<!--									<label><span>Inbound name </span>-->
				<!--										<p-->
				<!--											v-if="!form.data.structure[sectionIndex].questions[questionIndex].apiMapping.customInbound"-->
				<!--											v-html="form.data.structure[sectionIndex].questions[questionIndex].apiMapping.inbound"/>-->
				<!--										<input-->
				<!--											v-if="form.data.structure[sectionIndex].questions[questionIndex].apiMapping.customInbound"-->
				<!--											type="text"-->
				<!--											v-model="form.data.structure[sectionIndex].questions[questionIndex].apiMapping.inbound">-->
				<!--									</label>-->
				<!--								</label>-->
				<!--							</div>-->
				<!--						</div>-->
				<!--					</fieldset>-->
				<!--				</v-tab>-->
				<v-tab id="preview" v-slot="{ tabIndex }" label="Preview">
					<fieldset v-for="(section, sectionIndex) in form.data.structure">
						<div>
							<div>
								<legend v-if="section.title"><span v-html="section.title"></span></legend>
								<div v-if="section.script" class="editorial" v-html="section.script"></div>
							</div>
							<div>
								<label
									v-for="(question, questionIndex) in form.data.structure[sectionIndex].questions"
									:key="questionIndex"
									:class="{checkbox: 'checkbox' === question.type}">
									<span v-html="question.question"></span>
									<input v-if="'checkbox' === question.type" type="checkbox">
									<input v-if="'number' === question.type" type="number">
									<money v-if="'money' === question.type"/>
									<select v-if="'select' === question.type">
										<option
											v-for="(option, optionIndex) in question.options" :key="optionIndex"
											:value="option.label" v-html="option.label"></option>
									</select>
									<input v-if="'text' === question.type" type="text">
									<textarea v-if="'textarea' === question.type"></textarea>
								</label>
							</div>
						</div>
					</fieldset>
					<div class="actions">
						<ul>
							<li>
								<process-button
									:processing="form.processing" :text="$attrs.cta"
									class="button button--primary"/>
							</li>
						</ul>
					</div>
				</v-tab>
			</v-tabs>
		</template>
	</form>
</template>
<script>
import {createNamespacedHelpers} from "vuex";
import MoneyField from "../../../../movingBuddies/views/protocolPack/forms/MoneyField.vue";

const {mapActions} = createNamespacedHelpers("factFinds");

export default {
	components: {MoneyField},
	data() {
		return {
			formReady: false,
			form: this.newForm({
				service: "",
				structure: [{
					conditional: false,
					conditionalQuestionIndex: null,
					conditionalAnswers: [],
					title: null,
					includeScript: false,
					script: null,
					questions: [{
						conditional: false,
						conditionalQuestionIndex: null,
						conditionalAnswers: [],
						question: null,
						type: null,
						options: [{
							label: null,
						}],
						apiMapping: {
							inbound: null,
							customInbound: false,
							outbound: null,
						},
					}],
				}],
			}),
		};
	},

	props: {
		factFind: null,
		method: {
			type: String,
			default() {
				return "post";
			},
		},
	},

	computed: {
		multipleSections() {
			return _.keys(this.form.data.structure).length > 1;
		},
	},

	methods: {
		...mapActions([
			"addModel",
			"updateModel",
		]),
		loadExistingFactFind() {
			let self = this;
			let existingFactFind = _.find(self.form.options.factFinds, function (factFind) {
				return factFind.service_provider_id === self.form.data.service_provider &&
					factFind.service_id === self.form.data.service;
			});

			if (!existingFactFind) {
				return;
			}

			this.form.set("structure", existingFactFind.structure);
		},
		sectionId(sectionIndex) {
			return "section-" + (sectionIndex + 1);
		},
		sectionTitle(index) {
			return this.form.getData("structure", index).title || "Section " + parseInt(parseInt(index) + 1);
		},
		multipleQuestions(sectionIndex) {
			return _.keys(this.form.getData("structure", sectionIndex).questions).length > 1;
		},
		multipleOptions(sectionIndex, questionIndex) {
			return _.keys(this.form.getData("structure." + sectionIndex + ".questions." + questionIndex + ".options")).length > 1;
		},
		addSection(index, before) {
			this.form.pushDefault("structure", index, before);
		},
		removeSection(index) {
			this.form.removeIndex("structure", index);
		},
		questionTitle(sectionIndex, index) {
			return this.form.getData("structure[" + sectionIndex + "].questions", index).question || "Question " + parseInt(parseInt(index) + 1);
		},
		addQuestion(sectionIndex, index, before) {
			this.form.pushDefault("structure[" + sectionIndex + "].questions", index, before, "structure[0].questions");
		},
		removeQuestion(sectionIndex, index) {
			this.form.removeIndex("structure[" + sectionIndex + "].questions", index);
		},
		addOption(sectionIndex, questionIndex, optionIndex, before) {
			this.form.pushDefault("structure[" + sectionIndex + "].questions[" + questionIndex + "].options", optionIndex, before, "structure[0].questions[0].options");
		},
		removeOption(sectionIndex, questionIndex, optionIndex) {
			this.form.removeIndex("structure[" + sectionIndex + "].questions[" + questionIndex + "].options", optionIndex);
		},
		setDefaultInboundApiMapping(sectionIndex, questionIndex) {
			let question = this.form.data.structure[sectionIndex].questions[questionIndex];

			if (!question.apiMapping.customInbound) {
				this.form.set("structure[" + sectionIndex + "].questions[" + questionIndex + "].apiMapping.inbound", this.getDefaultInboundApiMapping(sectionIndex, questionIndex));
			}
		},
		getDefaultInboundApiMapping(sectionIndex, questionIndex) {
			return this.form.data.structure[sectionIndex].questions[questionIndex].question.replace(/ /g, "_").replace(/[^a-zA-Z\d\_]/g, "").toLowerCase();
		},
		resetDefaultInboundApiMapping(sectionIndex, questionIndex) {
			if (!this.form.data.structure[sectionIndex].questions[questionIndex].apiMapping.customInbound) {
				this.setDefaultInboundApiMapping(sectionIndex, questionIndex);
			}
		},
		async submit() {
			if ("post" === this.method) {
				this.form.post("fact-finds").then(data => {
					this.addModel(data.data);
					this.$store.dispatch("alertsStore/success", "Fact Find Created");
				});
			}

			if ("patch" === this.method) {
				this.form.patch("fact-finds/" + this.factFind.id).then(data => {
					this.updateModel(data.data);
					this.$store.dispatch("alertsStore/success", "Fact Find Updated");
				});
			}
		},
	},

	created() {
		http().get("form-data/fact-find").then(response => {
			this.form.setOptions(response.data);
			this.form.pushDefault("structure");
			this.formReady = true;
			if (this.factFind) {
				this.form.prefill(this.factFind);
			}
		});
	},
};
</script>
